import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { updateOrganizationCall } from "api/api";
import { checkPermission } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import Modal from "../../components/modal";
import ImagePicker from "components/imagePicker/image_picker";
import { uploadLogoCall } from "api/api";

const defaultState = {
  logo: null,
  logo_url: "",
  logo_cdn_url: "",
  name: "",
  address: "",
  phoneNumber: "",
  isActive: false,
};

export default function UpdateOrganizationForm({ onClose, reload, organization }) {
  const [state, setState] = useState(defaultState);
  const onUpdate = async () => {
    if (!state.name) {
      return global.showAlert("Validation Errors", "Organization Name is required", "warning");
    }
    let newLogoUrl;
    if (state.logo) {
      const formData = new FormData();
      formData.append("file", state.logo);
      const fileResponse = await uploadLogoCall(formData);
      newLogoUrl = fileResponse.url;
    }

    const response = await updateOrganizationCall(organization.id, {
      logo_url: newLogoUrl || state.logo_url,
      name: state.name,
      address: state.address,
      phone_number: state.phoneNumber,
      is_active: state.isActive,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    if (organization) {
      setState({
        logo_url: organization.logo_url,
        logo_cdn_url: organization.logo_cdn_url,
        name: organization.name,
        address: organization.address,
        phoneNumber: organization.phone_number,
        isActive: organization.is_active,
      });
    } else {
      setState(defaultState);
    }
  }, [organization]);

  const setFile = (file) => {
    setState({ ...state, logo: file });
  };

  return (
    organization && (
      <Modal
        title={"Update organization"}
        open={!!organization}
        actions={
          <MDBox display="flex" gap={1} justifyContent="right">
            <MDButton onClick={onUpdate} variant="gradient" color="info">
              submit
            </MDButton>
            <MDButton onClick={onClose} variant="gradient" color="error">
              cancel
            </MDButton>
          </MDBox>
        }
      >
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <ImagePicker
              imageUrl={state.logo_cdn_url}
              setFile={setFile}
              file={state.logo}
              title={"Logo"}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Name"
              fullWidth
              value={state.name}
              onChange={(event) => {
                setState({ ...state, name: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Address"
              fullWidth
              value={state.address}
              onChange={(event) => {
                setState({ ...state, address: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Phone number"
              fullWidth
              value={state.phoneNumber}
              onChange={(event) => {
                setState({ ...state, phoneNumber: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={state.isActive}
                label="Status"
                style={{
                  paddingBottom: "0.75rem",
                  paddingTop: "0.75rem",
                }}
                onChange={(event) => {
                  setState({ ...state, isActive: event.target.value });
                }}
                disabled={!checkPermission(permissions().rolePermission().create().update().list())}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
        </MDBox>
      </Modal>
    )
  );
}
